module.exports = __webpack_public_path__ + "img/SMT_02_Mr_Noel_Cheah.dc004099.jpg";